module.exports = __webpack_public_path__ + "static/media/wx@2x.c831e901.png";